import { ROUTE_PATH, OperationType, USER_TYPE } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class MentoringDocumentGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Mentoring Documents',
            ROUTE_PATH.mentoringDocument,
            ROUTE_PATH.addMentoringDocument,
            false,
            true,
            8,
            false,
            true,
            ['year'],
            true,
            [],
            { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
            false,
            { evalKey: '', evalParam: [''], decisiveParam: false },
            false,
            false,
            false,
            null,
            null,
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            false,
            [], true, { isExtraActions: false, btnLabel: '' },
            {isCheckboxEmit: false, emitKey: 'id', checkedKey: '', valueKey: ''},
            {
                isDownload: false,
                key: '',
                valueKey: '',
              },
              {
                isTabStatus: false,
                label: '',
                isChecked: false,
              },
              false,
              false
        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const year_number = new Headers('Year', 'year', false, true, 'text');
        const quarter_number = new Headers('Quarter', 'quarter_number', false, true, 'text');
        const preview = new Headers('Mentoring Document', 'mentoringDoc', false, true, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        const mentoringDoc = new Headers('', 'mentoringDoc', false, true, 'mentoringDoc');
        headers.push(year_number);
        headers.push(quarter_number);
        headers.push(preview);
        // headers.push(mentoringDoc);
        return headers;
    }

    getApprovalStatus() {
        const userRole = JSON.parse(localStorage.getItem('profile')).role;
        return userRole === USER_TYPE.admin;
    }
}
